module.exports = __webpack_public_path__ + "img/1F628.9219fdac.svg";